import { getController } from '@/services/service'

const url = 'handoveragreements'

export const handoverAgreementService = {
	...getController<
		Api.HandoverAgreement,
		Api.HandoverAgreementPostInput,
		Api.HandoverAgreementUpdateInput
	>(url),
}
